import addEventCapabilities from "./event_capabilities_queued.js"

function eventBus (nameSpace) {
    return eventBus.createOrFindEventNameSpace(nameSpace)
}

addEventCapabilities(eventBus)

export default eventBus

